import * as z from "zod";

import { MUNICIPAL_PROPERTY_REGISTER_YEAR_BOUNDS } from "@ark/shared";

interface RegisterCreateFormMessages {
  yearRange: string;
}

interface BuildMunicipalPropertyRegisterCreateFormSchemaOptions {
  messages: RegisterCreateFormMessages;
}

export function buildMunicipalPropertyRegisterCreateFormSchema({
  messages,
}: BuildMunicipalPropertyRegisterCreateFormSchemaOptions) {
  return z.object({
    year: z
      .number({ invalid_type_error: messages.yearRange })
      .int(messages.yearRange)
      .min(MUNICIPAL_PROPERTY_REGISTER_YEAR_BOUNDS.min, messages.yearRange)
      .max(MUNICIPAL_PROPERTY_REGISTER_YEAR_BOUNDS.max, messages.yearRange),
  });
}
